var PushStatus = {      
    status : false, 
    social : 2,
    constructor :  function(config){
        this.config = config;
        this.upper  = typeof(myStorage.get('upper_push')) === 'undefined' ? false : 1*myStorage.get('upper_push');
        this.used   = typeof(myStorage.get('used_push')) === 'undefined' ? false : 1*myStorage.get('used_push');
        this.initiateCheck();
        return this;
    },
    initiateCheck : function(){
        if(this.upper === false){
            myStorage.set('upper_push', 0, this.config.expire );
            this.upper = 0;
        }
        if(this.used === false){
            myStorage.set('used_push', 0, this.config.expire );
            this.used = 0;
        }
    },
    check : function(){
        if(this.config.statein == 1){
            if(this.config.sync_social != 1 || (this.social == 3 && this.config.sync_social == 1)){
                if (this.upper >=  this.config.wait && this.used < this.config.max) {
                    if((this.upper - this.config.wait) % this.config.between == 0 || this.upper - this.config.wait == 0){
                        this.status = true;     
                        myStorage.set('used_push', this.used + 1,this.config.expire);
                    }
                }
                myStorage.set('upper_push', this.upper + 1, this.config.expire);
            }
        }
    },
    getStatus : function(){
        return this.status;
    },
    setSocialStatus : function(status){
        this.social = status;    
    },
    checkSocailSync : function(){
        if(this.config.sync_social == 1 && this.social != 3){
            this.status = false;        
        } 
    }
}
var time_checkFlag = 0;
function checkFlag(push,push_status) {
    if(popup.statein < 2 && time_checkFlag < 40) {
        time_checkFlag += 1;
        window.setTimeout(function(){
            checkFlag(push,push_status)
            }, 2000); /* this checks the flag every 100 milliseconds*/
    } else {
        push_status.setSocialStatus(popup.statein);
        push_status.check();
        return pushIn(push,push_status.getStatus());
        return;
    }
}
$(document).ready(function() {
    var push_status = Object.create(PushStatus).constructor(push); 
    checkFlag(push,push_status);
});
function pushIn(push,pop){
    $.getScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js', function(){
        var OneSignal = window.OneSignal || []; 
        OneSignal.push(["init", {
            appId: push.appid,
            autoRegister: false, /* Set to true to automatically prompt visitors */
            notifyButton: {
                enable: true,
                size: 'medium', /* One of 'small', 'medium', or 'large' */
                theme: 'default', /* One of 'default' (red-white) or 'inverse" (white-red) */
                position: 'bottom-left', /* Either 'bottom-left' or 'bottom-right' */
                prenotify: true, /* Show an icon with 1 unread message for first-time site visitors */
                showCredit: true, /* Hide the OneSignal logo */
                text: push.text
            },
            promptOptions: push.promptOptions

        }]);
        if(pop === true){
            OneSignal.push(function() {
                OneSignal.showHttpPrompt();
            });
        }
    });
}